import React from 'react'
import { get, post } from 'aws-amplify/api'

import MetricsContext from '../context/MetricsContext'

const MetricsProvider = ({ children }) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL
  const getQuestions = async () => {
    try {
      const resp = get({
        apiName: baseUrl,
        path: '/membership/getMetricsInfo',
        options: {
          headers: {
            'content-type': 'application/json'
          },
          body: {
            name: 'Membresía Integral'
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()
      return data
    } catch (error) {
      console.log(error)
    }
  }

  const setMetrics = async (tokenAuth, body) => {
    if (tokenAuth !== '') {
      try {
        const resp = post({
          apiName: baseUrl,
          path: '/membership/setMetricsInfo',
          options: {
            headers: {
              'content-type': 'application/json',
              Authorization: `Bearer ${tokenAuth.__raw}`
            },
            body
          }
        })
        const { body: responseBody } = await resp.response
        const data = await responseBody.json()
        return data
      } catch (error) {
        console.log(error)
      }
    }
  }

  return (
    <MetricsContext.Provider
      value={{
        getQuestions,
        setMetrics
      }}
    >
      {children}
    </MetricsContext.Provider>
  )
}

export default MetricsProvider
